import { useAppDispatch } from "../../../app/hooks";
import {
    Button,
    ProductsLayoutSwitch,
} from "@hatch-digital-nl/bravilor-storybook";
import { Filters } from "./Filters";
import {
    setGridLayout,
    setMobileFiltersActive,
} from "../../../pages/productRangePage/ProductRangeSlice";
import { FilterListInterface } from "../../interfaces/FilterListInterface";
import { JSX } from "react";

export const ContentNavigation = ({
    mobileFiltersActive,
    filters,
    selectedFilters,
    gridLayout,
}: {
    mobileFiltersActive: boolean;
    filters: FilterListInterface[];
    selectedFilters: {
        [filterId: string]: {
            id: number;
            options: { id: string; value: string | number }[];
        };
    };
    gridLayout: boolean;
}): JSX.Element => {
    const dispatch = useAppDispatch();

    return (
        <div className="p-product-range__content-nav">
            <Filters
                filters={filters}
                selectedFilters={selectedFilters}
                onClose={() => dispatch(setMobileFiltersActive(false))}
                mobileFiltersActive={mobileFiltersActive}
            />
            <Button
                className="p-product-range__filters__button"
                transparent={true}
                onClick={() => dispatch(setMobileFiltersActive(true))}
            >
                <img
                    className="p-product-range-filters__button-icon"
                    src="/images/icons/filter.svg"
                    alt="filter"
                />
                Filter results
            </Button>

            <ProductsLayoutSwitch
                gridLayout={gridLayout}
                gridText="Grid"
                listText="List"
                isLoadingTranslations={false}
                onLayoutChange={() => dispatch(setGridLayout(!gridLayout))}
            />
        </div>
    );
};
